import React, { useEffect, useState } from 'react';
import UnitField from './UnitField';


const AddUnit = () => {
     return (
        <div className='mx-auto w-full p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add A New Unit Type</h1>
            <UnitField></UnitField>
        </div>
    );
};

export default AddUnit;